import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const MeteorShowerAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<12; i++){
    const ang = (i/12)*Math.PI*2;
    const startDst = e.maxRadius;
    const endDst = e.maxRadius + progress * 400;
    const rStart = getRadiusAtAngle(ang, e, startDst);
    const rEnd = getRadiusAtAngle(ang, e, endDst);
    
    ctx.beginPath();
    ctx.moveTo(e.pos.x + Math.cos(ang)*rStart, e.pos.y + Math.sin(ang)*rStart);
    ctx.lineTo(e.pos.x + Math.cos(ang)*rEnd, e.pos.y + Math.sin(ang)*rEnd);
    ctx.lineWidth = 6 * (1-progress); ctx.stroke();
  }
};

registerBlastAnimation('METEOR_SHOWER', MeteorShowerAnimation);
